import { useDispatch } from "react-redux";
import { ModalType, UIMode, setModal } from "../../Redux/uiSlice";
import { Button } from "../Common/Button";
import { LinkDropDown } from "../Common/LinkDropDown";

interface IProps {
  mode?: UIMode;
  children?: React.ReactNode;
}

export const links = [{ text: 'Play', to: '/' }, { text: 'Build', to: '/build' }, { text: 'Leaderboard', to: '/leaderboard' }, { text: 'Assets', to: '/assets' }];

export const Layout: React.FC<IProps> = ({ mode, children }) => {

  const dispatch = useDispatch();

  return (
    <div className="bg-antiqueWhite flex flex-col justify-center items-center p-3 sm:p-4 relative h-dvh box-border">
      <div className="hidden sm:flex ml-auto h-12">
        <LinkDropDown links={links} />
        <div className='w-12 h-12 ml-4'>
          <Button
            text='?'
            onClick={() => dispatch(setModal(ModalType.HELP))}
            className='w-12 text-sm font-black h-12 bg-white'
          />
        </div>
      </div>
      {children}
    </div>
  )
}
